module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "inline",
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id,
      "for": "label"
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.field_data
    }
  }), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "config": _vm.editorConfig,
      "read-only": _vm.readonly,
      "name": _vm.name,
      "required": _vm.isRequired
    },
    model: {
      value: (_vm.field_data.value),
      callback: function($$v) {
        _vm.$set(_vm.field_data, "value", $$v)
      },
      expression: "field_data.value"
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d964577"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/richtext.vue
// module id = 973
// module chunks = 0